import React, { useEffect, useReducer, useState } from 'react';

import { useAuth } from '../../Context';
import { Content } from 'antd/es/layout/layout';
import { Avatar, Button, Card, Col, Empty, Form, Input, message, Modal, Popover, Row,  Space, Spin, Switch, Table,  Typography } from 'antd';
import {  BellOutlined, DeleteOutlined, EditOutlined, InfoOutlined, PlusOutlined } from '@ant-design/icons';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import axios from 'axios';
import NotificationManagementReducer from './reducer';
import {  NOTIFICATION_MANAGEMENT_LIST_ERROR, NOTIFICATION_MANAGEMENT_LIST_SUCCESS, NOTIFICATION_MANAGEMENT_LIST, ADD_NOTIFICATION_TYPE, ADD_NOTIFICATION_TYPE_SUCCESS, ADD_NOTIFICATION_TYPE_ERROR, NOTIFICATION_MANAGEMENT_DETAILS, NOTIFICATION_MANAGEMENT_DETAILS_ERROR, NOTIFICATION_MANAGEMENT_DETAILS_SUCCESS, NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS, NOTIFICATION_MANAGEMENT_UPDATE, NOTIFICATION_MANAGEMENT_UPDATE_ERROR, DELETE_NOTIFICATION, DELETE_NOTIFICATION_SUCCESS, DELETE_NOTIFICATION_ERROR } from './constants';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
// import { Option } from 'antd/es/mentions';


const { Title } = Typography;

export default function NotificationMangement() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const initalState = { loading: false, error: false,details:null, notifications : [], pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [data, dispatch] = useReducer(NotificationManagementReducer, initalState);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteNotificationModal, setShowDeleteNotificationModal] = useState(false);
	
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));

	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;	
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	
	const navigate = useNavigate();
	
	useAuth();
	
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
		if(featuresModule.notificationManagementEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4012);
		loadNotificaitons();
	}, []);
	
	
	const loadNotificaitons = ()=>{
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/stsnotificationtype/?pipelineId=${pipelineId}&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		dispatch({type : NOTIFICATION_MANAGEMENT_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
									
					dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_SUCCESS, payload: response.data.data });
				} else {
					dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const handleToggle = (value,record,key)=>{
	
		let config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: `${api}/stsnotificationtype/${record.id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${authtoken}`
			},
			data: {
				[key] : value
					
			}
		}; 
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch( { type: NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS, payload: response.data.data });
					Modal.success({ title: `${langdata && langdata.NotificationUpdatedSuccessfully ? langdata.NotificationUpdatedSuccessfully :'Notification updated successfully'}` });
					formik.resetForm();
					setOpenEditDrawer(false);
					loadNotificaitons();
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type: NOTIFICATION_MANAGEMENT_UPDATE_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	
	};

	const openDeleteNotificationModal = () => {
		// setShowDeleteGeofenceManagementModal(true);
		setShowDeleteNotificationModal(true);
	};
		
	const closeDeleteNotificationModal = () => {
		setShowDeleteNotificationModal(false);
	};

	const deleteNotification = () => {
		const id = parseInt(data.details.id);
			
		dispatch({ type: DELETE_NOTIFICATION });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/stsnotificationtype/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_NOTIFICATION_SUCCESS, payload: response});
					setShowDeleteNotificationModal(false);   
					loadNotificaitons();       
				} else {
					dispatch({type:DELETE_NOTIFICATION_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_NOTIFICATION_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};


	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
			width : 200
		},
		{
			title: `${langdata&&langdata.Status?langdata.Status:'Status'}`,
			dataIndex: 'enabled',
			key: 'enabled',
			width : 100,

			render: (toggle, record) => (
				
				<>
					<Switch size='small'  value={toggle}  onChange={(value) => handleToggle(value,record,'enabled')} />
				</>
			),
		},
		{
			title: `${langdata&&langdata.ApiEnabled?langdata.ApiEnabled:'API Enabled'}`,
			dataIndex: 'apiEnabled',
			key: 'apiEnabled',
			width : 100,

			render: (toggle, record) => (
				<>
					
					<Switch size='small'  value={toggle} onChange={(value) => handleToggle(value,record,'apiEnabled')} />
				</>
			),
		},
		{
			title: `${langdata&&langdata.WhatsAppEnabled?langdata.WhatsAppEnabled:'WhatsApp Enabled'}`,
			dataIndex: 'whatsappEnabled',
			key: 'whatsappEnabled',
			width : 100,

			render: (toggle, record) => (
				<>
					
					<Switch size='small'  value={toggle} onChange={(value) => handleToggle(value,record,'whatsappEnabled')} />
				</>
			),
		},
		{
			title: `${langdata&&langdata.telegramEnabled?langdata.telegramEnabled:'Telegram Enabled'}`,
			dataIndex: 'telegramEnabled',
			key: 'telegramEnabled',
			width : 100,

			render: (toggle, record) => (
				<>
						
					<Switch size='small' value={toggle} onChange={(value) => handleToggle(value,record,'telegramEnabled')} />
				</>
			),
		},
		{
			title: `${langdata&&langdata.SMSEnabled?langdata.SMSEnabled:'SMS Enabled'}`,
			dataIndex: 'smsEnabled',
			key: 'smsEnabled',
			width : 100,

			render: (toggle, record) => (
				<>
					
					<Switch size='small' value={toggle} onChange={(value) => handleToggle(value,record,'smsEnabled')} />
				</>
			),
		},
		{
			title: `${langdata&&langdata.pushNotificationEnabled?langdata.pushNotificationEnabled:'Push Notification Enabled'}`,
			dataIndex: 'pushNotificationEnabled',
			key: 'pushNotificationEnabled',
			width : 100,

			render: (toggle, record) => (
				<>
					
					<Switch size='small' value={toggle} onChange={(value) => handleToggle(value,record,'pushNotificationEnabled')} />
				</>
			),
		},
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: '',
			align:'center',
			width : 100,

			render: () => (
						
		
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={showEditDrawer}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={openDeleteNotificationModal}><DeleteOutlined /></a>

					</Space>
				</>
			)
		}
	];

	const handleOk = () => {
		setIsAddModalOpen(false);
	};
	const handleCancel = () => {
		setIsAddModalOpen(false);
	};
	const showEditDrawer = () => {
		setOpenEditDrawer(true);
	};	
	const handleModalCancel = () => {
		setOpenEditDrawer(false);
	};

	const createFormik = useFormik({
		// enableReinitialize: true,
		initialValues : {
			name : null,
			
			
		},
		onSubmit: (values) => {
			
			if( name == null){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
		
			
			dispatch({ type : ADD_NOTIFICATION_TYPE });
			let data = JSON.stringify({
				'name' : values.name,
				'pipelineId':parseInt(pipelineId),
				enabled : false,
				apiEnabled: false,
				whatsappEnabled:false,
				telegramEnabled:false,
				smsEnabled : false
				
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/stsnotificationtype`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201){	
						Modal.success({ title: langdata && langdata.NotificationAddedSuccessfully ? langdata.NotificationAddedSuccessfully : 'Notification added successfully' });	
									
						dispatch({ type : ADD_NOTIFICATION_TYPE_SUCCESS  } );
						loadNotificaitons();	
						createFormik.resetForm();
						setIsAddModalOpen(false);
					} else {
						dispatch({ type : ADD_NOTIFICATION_TYPE_ERROR });
						Modal.warning({ title: langdata && langdata.Unabletoadd ? langdata.Unabletoadd : 'Unable to add' });					
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : ADD_NOTIFICATION_TYPE_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.UnableToAddNotification ? langdata.UnableToAddNotification : 'Unable to add notification' });					
					}
				});

		}
	});	

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}> {langdata && langdata.NotificationManagementInfoContent ? langdata.NotificationManagementInfoContent : 'This module manages and monitors all system notifications in one centralized dashboard, delivering alerts to allowed users via Telegram groups, WhatsApp messages to assigned numbers, SMS to assigned numbers, and Android push notifications.'} </p>
		</Card>
	);

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.name || '',
		},
		onSubmit: (values) => {
		
			dispatch({type:NOTIFICATION_MANAGEMENT_UPDATE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/stsnotificationtype/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					// enabled: values.enabled,
					pipelineId : parseInt(pipelineId)
					
				}
			}; 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {

						dispatch( { type: NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS, payload: response.data.data });
						Modal.success({ title: `${langdata && langdata.NotificationUpdatedSuccessfully ? langdata.NotificationUpdatedSuccessfully :'Notification updated successfully'}` });
						formik.resetForm();
						setOpenEditDrawer(false);
						loadNotificaitons();
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type: NOTIFICATION_MANAGEMENT_UPDATE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});

	const loadNotificationDetails = ((record) => {
		dispatch( { type: NOTIFICATION_MANAGEMENT_DETAILS });
			
		if (!record) {
			dispatch({ type: NOTIFICATION_MANAGEMENT_DETAILS_ERROR });
		} else {
			dispatch({ type: NOTIFICATION_MANAGEMENT_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	return (
		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<BellOutlined style={{fontSize:'30px'}}/>
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.NotificationManagement ? langdata.NotificationManagement : 'Notification Management'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
							{ permission==='superadmin' || permission === 'admin' ? 
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={() => {setIsAddModalOpen(true);}}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;&nbsp;</Space>
							
							<Popover title={langdata && langdata.NotificationManagement ? langdata.NotificationManagement : 'Notification Management'}  content={infoContent} trigger="click">
								<Avatar size="small"><InfoOutlined /></Avatar>
							</Popover>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					{ data.notifications && data.notifications && data.notifications.length > 0 ? (
						<Table
							scroll={{
								x: 900,
							}}
							columns = { columns } 
							dataSource = { data.notifications } 
							onChange={loadNotificaitons}
							onRow = {(record) => {
								return {
									onClick: () => { 
										loadNotificationDetails(record);

												
									}
								};
							}}
						/>
					)
						:
						(
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
				</Col>
			</Row>


			<Modal
				title={langdata && langdata.AddNotificationManagement ? langdata.AddNotificationManagement : 'Add notification management'}
				centered
				open={isAddModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				destroyOnClose= {true}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={createFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={500}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name' }]} required>
								<Input 
									name="name" 
									placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
									onChange={createFormik.handleChange} 
								/>
							</Form.Item>
						</Col>
					</Row>
					
				</Form>
			</Modal>

			<Modal
				title={langdata && langdata.EditNotificationMangementDetails ? langdata.EditNotificationMangementDetails:'Edit notification management details'}
				width={500}
				centered
				destroyOnClose={true}
				maskClosable={false}
				onOk={formik.handleSubmit}
				onCancel={handleModalCancel}
				open={openEditDrawer}
				styles={{
					body: {
					},
				}}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleModalCancel}>
							{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
						</Button>
						<Button onClick={formik.handleSubmit} type="primary">
							{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
						</Button>
					</Space>
				]}
			>
				<Form onSubmit={formik.handleSubmit} layout="vertical"
					
				>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name:'Name'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
								<Input name="name" value={formik.values.name} onChange={formik.handleChange} defaultValue={data?.details?.name}  placeholder={langdata && langdata.Name ? langdata.Name:'Name'} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>
			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteNotificationModal} onOk={deleteNotification} onCancel={closeDeleteNotificationModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> { langdata && langdata.Areyousureyouwanttodeletethis ? langdata.Areyousureyouwanttodeletethis : 'Are you sure you want to delete this' }</Col>
				</Row>
			</Modal>
			<Spin fullscreen spinning={data.loading} />
		</Content>
	);
}